export const themeA = {
  name: "手繪日記",
  colors: {
    bg: "#F7F3EE",
    bgSecondary: "#F0EBE3",
    text: "#2A2A2A",
    textSecondary: "#8A8278",
    textMuted: "#6B6258",
    accent: "#E8A0BF",
    accentText: "#2A2A2A",
    accentAlt: "#7BB5CF",
    accentWarm: "#F0D58C",
    accentOrange: "#E8A672",
    available: "#7BAF6E",
    availableText: "#1A1916",
    claimed: "#C4B5A0",
    cardBg: "#FFFFFF",
    cardBorder: "#EDE8E0",
    overlay: "rgba(255,252,247,0.75)",
    heroBg: "#1A1916",
    heroText: "#F0EBE3",
  },
  fonts: {
    heading: "'Zen Maru Gothic', 'Noto Sans TC', sans-serif",
    body: "'Noto Sans TC', sans-serif",
    accent: "'Caveat', cursive",
  },
  // Dynamic-loaded fonts (see lib/dynamicFonts.js). Zen Maru + Noto Sans TC
  // are shipped via next/font in the critical path; Caveat is loaded here
  // only when this theme activates.
  fontUrls: ["https://fonts.googleapis.com/css2?family=Caveat&display=swap"],
  radius: { sm: "10px", md: "16px", lg: "24px", full: "9999px" },
  spacing: { cardGap: "20px", sectionGap: "48px", pagePadding: "20px" },
  effects: {
    cardShadow: "0 2px 12px rgba(0,0,0,0.06)",
    cardHoverShadow: "0 4px 20px rgba(0,0,0,0.10)",
    bgTexture: true,
    textureOpacity: 0.03,
  },
};
